import {createAction} from '@reduxjs/toolkit'
import {isEditor} from '../../../../commons/utils/wix-code-api'
import {MembersViewState} from '../../constants'
import {getEventList} from '../selectors/events'
import {createAsyncAction} from '../services/redux-toolkit'
import {closeAllEvents, toggleEventDetails} from './events'

export const handleViewState = createAsyncAction<void, MembersViewState>(
  'HANDLE_VIEW_STATE',
  (viewState, {dispatch, getState}) => {
    if (viewState === MembersViewState.DEFAULT) {
      dispatch(showNoEvents(false))
      dispatch(showDemoEvents())
      dispatch(closeAllEvents())
    }

    if (viewState === MembersViewState.NO_EVENTS) {
      dispatch(showNoEvents(true))
    }

    if (viewState === MembersViewState.DETAILS) {
      const events = getEventList(getState())

      dispatch(showNoEvents(false))
      events.slice(0, 2).forEach(event => dispatch(toggleEventDetails({event})))
    }
  },
  {
    condition: (_, {extra: {wixCodeApi}}) => isEditor(wixCodeApi),
  },
)

export const showDemoEvents = createAction('SHOW_DEMO_EVENTS')

export const showNoEvents = createAction<boolean>('SHOW_NO_EVENTS')
